import { apiSlice } from "../../app/api/apiSlice";
import { showToast } from "../../toastify/Toast";
import { ClientData, ReportByChapelIDResponse, ReportByChapelIDSummary, ReportByDateRangeAndChapelIDResponse, ReportByDateRangeAndChapelIDSummary, ReportsByChapelID } from "../../types/reports";

export const reportsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getReportsByChapelId: builder.query<{ clients: ReportsByChapelID[]; summary: ReportByChapelIDSummary }, number>({
            query: (chapelID) => `api/reports/session-orders/chapel/${chapelID}`,
            transformResponse: (response: ReportByChapelIDResponse) => response.data,
            transformErrorResponse: (response) => response.data,
        }),
        getReportByDateRangeAndChapels: builder.query<{ items: ClientData[] | null; summary: ReportByDateRangeAndChapelIDSummary }, { startDate: string; endDate: string; chapelIds: number[] }>({
            query: ({ startDate, endDate, chapelIds }) => {
                const chapelIdsParam = chapelIds.join(',');

                return `api/reports/report-sales?startDate=${startDate}&endDate=${endDate}&chapelIds=${chapelIdsParam}`;
            },
            transformResponse: (response: ReportByDateRangeAndChapelIDResponse) => response.data,
            transformErrorResponse: (response) => response.data,
        }),
        exportSalesExcel: builder.mutation<Blob, { startDate: string; endDate: string; chapelIds?: number[]; clientID?: number; }>({
            query: (body) => ({
                url: "api/reports/export-sales-excel",
                method: "POST",
                body,
                responseHandler: (response) => response.blob(),
            }),
        }),
        exportBillingReport: builder.mutation<Blob, { clientId: number; type?: "summary" | "detailed" }>({
            query: ({ clientId, type }) => ({
                url: `api/reports/${clientId}/export-billing-excel`,
                params: { type },
                responseHandler: (response) => response.blob(),
            }),
        }),
    }),
});

export const { 
    useGetReportsByChapelIdQuery,
    useGetReportByDateRangeAndChapelsQuery,
    useExportSalesExcelMutation,
    useExportBillingReportMutation,
} = reportsApiSlice;